module.exports = __webpack_public_path__ + "img/source_of_stress.8dfcdda3.svg";